module.exports = require('./helpers/bundle-url').getBundleURL('fJUuz') + "logo-dark.eefe0b7f.svg";